import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, Slider, TextField, Typography } from "@mui/material";
import { colors } from "../../../theme/muiColors";
import { SuppliesProvider } from "../components/SuppliesProvider";
import { ArrowDropDown as ArrowDropDownIcon, Add, Delete } from "@mui/icons-material";
import TuneIcon from "@mui/icons-material/Tune";
import CropIcon from "@mui/icons-material/Crop";
import { Controller } from "react-hook-form";

export const ConfigureJobService = ({ setValue, control, service: watchService, serviceOptions }) => {

  const currentService = serviceOptions?.find((service) => watchService === service.workServices.id);

  const handleSetAllSuppliesForJob = (jobServiceId, selectedSuppliesArray) => {
    setValue("supplies", selectedSuppliesArray.flat());
  };

  if (!currentService) return null;

  return (
    <>
      <Typography fontSize={17} variant="h4" sx={{ mb: 2, color: colors.blueGrey[800], mt: 4 }}>
        Configure job services
      </Typography>

      <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Accordion defaultExpanded sx={{ width: "100%", bgcolor: colors.grey[100], borderRadius: 2, mb: 1 }}>
          <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
            <TuneIcon sx={{ color: colors.blueGrey[600], mr: 1 }} />
            <Typography sx={{ color: colors.blueGrey[600] }} variant="body1">
              {currentService.workServices.name}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Divider sx={{ mb: 2 }} />
            <Typography sx={{ color: colors.blueGrey[700], mb: 2 }}>{currentService.workServices.description}</Typography>

            <Grid item xs={12} /> <SuppliesProvider setAllSuppliesForJob={handleSetAllSuppliesForJob} jobServiceId={1} jobServiceName={currentService.workServices.name} />

            {/* Square ft */}
            <Grid item xs={12} md={3} display="flex" alignItems="center">
              <CropIcon sx={{ color: colors.blue[900] }} />
              <Typography sx={{ ml: 1 }} color={colors.blue[900]}>
                Square ft.
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} sx={{ p: 1 }}>
              <Controller
                name="squareFt"
                control={control}
                defaultValue={100}
                rules={{
                  required: true,
                  min: { value: 1, message: "Mínimo 1" },
                  max: { value: 10000, message: "Máximo 10000" },
                }}
                render={({ field: { value, onChange, onBlur, ref } }) => (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Slider
                      value={typeof value === "number" ? value : Number(value)}
                      min={0}
                      max={10000}
                      step={10}
                      valueLabelDisplay="on"
                      sx={{ color: colors.blue[300], flex: 1 }}
                      onChange={(_, v) => onChange(Array.isArray(v) ? v[0] : v)}
                      onBlur={onBlur}
                    />

                    <TextField
                      inputRef={ref}
                      size="small"
                      label="Square ft"
                      type="number"
                      value={value ?? ""}
                      onChange={(e) => {
                        const raw = e.target.value;
                        if (raw === "") {
                          onChange("");
                          return;
                        }
                        const num = Number(raw);
                        if (Number.isNaN(num)) return;
                        const clamped = Math.max(1, Math.min(10000, num));
                        onChange(clamped);
                      }}
                      onBlur={() => {
                        if (value === "" || value == null) onChange(1);
                      }}
                      inputProps={{ min: 1, max: 10000 }}
                      sx={{ width: { xs: "100%", sm: 140 } }}
                    />
                  </Box>
                )}
              />
            </Grid>

          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};
